export enum RedeemType {
  DayOfEvent,
  AnytimeDuringAndAfter,
  DaysAfterEvent
}
